module.exports = __webpack_public_path__ + "static/media/circle2.66208f2b.svg";